import React, { Component } from 'react';
import { connect } from 'react-redux';
import EbayView from './Ebay.view';

export class EbayContainer extends Component {
  render() {
    return (<EbayView
      {...this.props}
      logout={this.logout}
    />);
  }

}

function mapStateToProps(state) {
  return {
    rateLimitRemaining: state.app.rateLimitRemaining,
  };
}

export default connect(mapStateToProps)(EbayContainer);



// WEBPACK FOOTER //
// ./src/app/modules/Ebay/Ebay.container.js